// extracted by mini-css-extract-plugin
module.exports = {"leftColumn":"styles_leftColumn__HPDfu","mobileImage":"styles_mobileImage__EAg22","rightColumn":"styles_rightColumn__GcvAL"};